export const mutations = {
  SET_EMPLOYEES(state, payload) {
    state.employees = payload
  },
  SET_SELECTED_EMPLOYEE(state, payload) {
    state.selectedEmployee = payload
  },
}
